module.exports = __webpack_public_path__ + "img/Celery.83b527db.svg";